import { render, staticRenderFns } from "./IframePageView.vue?vue&type=template&id=239a8f59&"
import script from "./IframePageView.vue?vue&type=script&lang=js&"
export * from "./IframePageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports